import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { ToolTip } from 'components/common/tooltips';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: ${colors.black2};
  background-color: ${colors.lightGray6};
  border-radius: 3px;
`;

export const TranslationTooltip = styled(ToolTip)`
  white-space: pre-line;
  padding: 8px 12px;
  font-family: Roboto;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  border-radius: 8px;
`;
